var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "is-flex is-align-items-center is-justify-content-space-between",
        },
        [
          [_vm.singleProcess.isOpen, _vm.bulkProcess.isOpen].includes(true)
            ? _c(
                "button",
                {
                  staticClass: "button is-button-secondary is-rounded mr-5",
                  on: { click: _vm.showTransactionsValidation },
                },
                [_vm._v(" " + _vm._s(_vm.$t("generalWords.GoBack")) + " ")]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "card-item mt-6 select-content",
          attrs: { id: "debt-selection-card" },
        },
        [
          _c("section", [
            _c(
              "div",
              {
                staticClass: "spinner-content is-flex is-align-content-center",
                class: _vm.isLoading ? "is-loading" : "is-hidden",
              },
              [_vm._m(0)]
            ),
            !_vm.isLoading
              ? _c("div", { staticClass: "fees-content" }, [
                  !_vm.singleProcess.isOpen && !_vm.bulkProcess.isOpen
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "field is-grouped",
                            attrs: { id: "validation-buttons" },
                          },
                          [
                            _vm.confirmableTransactionsLen
                              ? _c("p", { staticClass: "control" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-button-secondary is-rounded",
                                      attrs: { id: "filter-button" },
                                      on: {
                                        click: function ($event) {
                                          _vm.filters.isModalVisible = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(1),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("generalWords.Filter"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.$i18n.locale === "cl" &&
                            _vm.confirmableTransactionsLen
                              ? _c("p", { staticClass: "control" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-button-secondary is-rounded",
                                      attrs: {
                                        id: "bulk-button",
                                        disabled: !_vm.checkUserFeature(
                                          "element.transaction-approvals.button.lotes"
                                        ),
                                      },
                                      on: { click: _vm.openBulkProcess },
                                    },
                                    [
                                      _vm._m(2),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("generalWords.Bulk"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        !_vm.isLoading &&
                        _vm.badTransactionsResponse.type !== null
                          ? _c(
                              "div",
                              {
                                staticClass: "message-info has-text-centered",
                                class:
                                  _vm.badTransactionsResponse.type === "error"
                                    ? "is-warning"
                                    : "is-info",
                                attrs: { id: "notification-message" },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-exclamation-circle is-pulled-left",
                                }),
                                _c("div", { staticClass: "message-text" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.badTransactionsResponse.message
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _c(
                              "div",
                              [
                                _vm.confirmableTransactionsLen
                                  ? _c(
                                      "h5",
                                      { staticClass: "has-text-centered mb-3" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("transactions.thereAre")
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "has-text-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.confirmableTransactionsLen
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    `generalWords.transaction${
                                                      _vm.confirmableTransactionsLen >
                                                      1
                                                        ? "s"
                                                        : ""
                                                    }`
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("transactions.toValidate")
                                            ) +
                                            ", "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "has-text-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.filteredTransactionsLen >
                                                    0
                                                    ? `mostrando ${_vm.filteredTransactionsLen}`
                                                    : _vm.$t(
                                                        "transactions.noCoincidences"
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-table",
                                  {
                                    attrs: {
                                      hoverable: "",
                                      data: _vm.filteredTransactions,
                                    },
                                  },
                                  [
                                    _c("b-table-column", {
                                      attrs: {
                                        field: "amount",
                                        label: _vm.$t("generalWords.Amount"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (transaction) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tag is-primary is-light is-size-6",
                                                    attrs: {
                                                      id: _vm.getTransactionId(
                                                        transaction.row
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatNumberByCountry(
                                                          transaction.row.amount
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2130771406
                                      ),
                                    }),
                                    _c("b-table-column", {
                                      attrs: {
                                        field: "createdAt",
                                        label: _vm.$t("generalWords.Antiquity"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (transaction) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.daysDiffFromToday(
                                                        transaction.row
                                                          .createdAt
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "generalWords.days"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2741652492
                                      ),
                                    }),
                                    _c("b-table-column", {
                                      attrs: {
                                        field: "clientName",
                                        label: _vm.$t("generalWords.Name"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (transaction) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      transaction.row.client
                                                        .name
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      transaction.row.client
                                                        .lastName
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1194510676
                                      ),
                                    }),
                                    _c("b-table-column", {
                                      attrs: {
                                        field: "clientIdNumber",
                                        label: _vm.$t("generalWords.idNumber"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (transaction) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatRut(
                                                        transaction.row
                                                          .clientIdNumber
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        60832283
                                      ),
                                    }),
                                    _c("b-table-column", {
                                      attrs: {
                                        field: "createdAt",
                                        label: _vm.$t("generalWords.Date"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (transaction) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        transaction.row
                                                          .createdAt
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        4058120990
                                      ),
                                    }),
                                    _c("b-table-column", {
                                      attrs: { field: "button", label: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (transaction) {
                                              return [
                                                transaction.row.provider !==
                                                "SERVIPAG_BUTTON"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-button-primary is-rounded",
                                                        attrs: {
                                                          id: `${_vm.getTransactionId(
                                                            transaction.row
                                                          )}-review`,
                                                          disabled:
                                                            !_vm.checkUserFeature(
                                                              "element.transaction-approvals.button.register"
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openSingleProcess(
                                                              transaction.row
                                                                ._id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "generalWords.Check"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        737433296
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ])
                    : _vm._e(),
                  _vm.singleProcess.isOpen
                    ? _c(
                        "div",
                        [
                          _c("SingleProcess", {
                            attrs: {
                              "bank-entries": _vm.bankEntries,
                              "confirmable-transactions":
                                _vm.confirmableTransactions,
                              "current-transaction":
                                _vm.singleProcess.currentTransaction,
                              "current-transaction-id":
                                _vm.singleProcess.currentTransactionId,
                              "current-transaction-index":
                                _vm.singleProcess.currentTransactionIndex,
                              "debt-date-toggle": _vm.debtDateToggle,
                              "payment-providers": _vm.paymentProviders,
                              "provider-dictionary": _vm.providerDictionary,
                            },
                            on: {
                              "is-single-process-open": function ($event) {
                                _vm.singleProcess.isOpen = $event
                              },
                              "load-transactions": function ($event) {
                                return _vm.loadTransactions()
                              },
                              "update-transaction": _vm.updateTransaction,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.bulkProcess.isOpen
                    ? _c("div", [
                        _c("h3", { staticClass: "modal-title" }, [
                          _vm._v("Validación masiva"),
                        ]),
                        _c(
                          "section",
                          [
                            _c("h5", { staticClass: "is-size-5" }, [
                              _vm._v("Rendición Servipag"),
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.bulkProcess.bulkInputTransactionText,
                                    expression:
                                      "bulkProcess.bulkInputTransactionText",
                                  },
                                ],
                                staticClass: "textarea",
                                attrs: { rows: "2" },
                                domProps: {
                                  value:
                                    _vm.bulkProcess.bulkInputTransactionText,
                                },
                                on: {
                                  drop: function ($event) {
                                    $event.preventDefault()
                                    return _vm.readServipagFile.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  dragover: function ($event) {
                                    $event.preventDefault()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.bulkProcess,
                                      "bulkInputTransactionText",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _c("BankStatementDetails", {
                              attrs: {
                                "id-prefix": "servipag",
                                "bank-entries": _vm.bankEntries,
                                type: "radio",
                                "default-search": ["78.053.790-6"],
                                totals: false,
                              },
                              model: {
                                value: _vm.bulkProcess.selectedBankEntry,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.bulkProcess,
                                    "selectedBankEntry",
                                    $$v
                                  )
                                },
                                expression: "bulkProcess.selectedBankEntry",
                              },
                            }),
                            _c("h5", { staticClass: "is-size-5" }, [
                              _vm._v("Comentario"),
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.bulkProcess.comment,
                                    expression: "bulkProcess.comment",
                                  },
                                ],
                                staticClass: "input is-small",
                                attrs: {
                                  id: "text-input-comment",
                                  type: "text",
                                },
                                domProps: { value: _vm.bulkProcess.comment },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.bulkProcess,
                                      "comment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm.bulkProcess.errorText
                              ? _c("p", { staticClass: "help is-danger" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.bulkProcess.errorText) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "transaction-buttons has-text-right",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-button-secondary is-rounded mr-5",
                                    on: {
                                      click: function ($event) {
                                        _vm.bulkProcess.isOpen = false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("generalWords.GoBack")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "button is-button-primary is-pulled-right",
                                    attrs: {
                                      id: "bulk-process-button",
                                      rounded: "",
                                      loading: _vm.bulkProcess.loading,
                                    },
                                    on: {
                                      click: _vm.processBulkTransactionIds,
                                    },
                                  },
                                  [_vm._v(" Procesar ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: { width: 400 },
          model: {
            value: _vm.filters.isModalVisible,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "isModalVisible", $$v)
            },
            expression: "filters.isModalVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-card-body has-text-centered" },
            [
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "close-modal",
                    attrs: { id: "close-filter-modal" },
                    on: {
                      click: function ($event) {
                        _vm.filters.isModalVisible = false
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/ui/assets/img/plus-button.svg"),
                      },
                    }),
                  ]
                ),
              ]),
              _c("h3", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("generalWords.Filter")) + " "),
              ]),
              _c(
                "b-field",
                {
                  attrs: {
                    horizontal: "",
                    label: _vm.$t("generalWords.Month"),
                    "custom-class": "has-text-weight-normal",
                  },
                },
                [
                  _c(
                    "b-select",
                    {
                      attrs: {
                        id: "month",
                        expanded: "",
                        name: "month",
                        size: "is-small",
                        rounded: "",
                      },
                      model: {
                        value: _vm.filters.month,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "month", $$v)
                        },
                        expression: "filters.month",
                      },
                    },
                    [
                      _c("option", { attrs: { value: "", selected: "" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("transactions.filter.selectMonth"))
                        ),
                      ]),
                      _vm._l(
                        Object.keys(_vm.monthsToFilter).sort(),
                        function (key) {
                          return _c(
                            "option",
                            { key: key, domProps: { value: key } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.monthsToFilter[key]) + " "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                {
                  attrs: {
                    horizontal: "",
                    label: _vm.$t("generalWords.Operation"),
                    "custom-class": "has-text-weight-normal",
                  },
                },
                [
                  _c(
                    "b-select",
                    {
                      attrs: {
                        id: "typeOperationToFilter",
                        expanded: "",
                        name: "typeOperationToFilter",
                        size: "is-small",
                        rounded: "",
                      },
                      model: {
                        value: _vm.filters.typeOperation,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "typeOperation", $$v)
                        },
                        expression: "filters.typeOperation",
                      },
                    },
                    [
                      _c("option", { attrs: { value: "", selected: "" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("transactions.filter.selectOperation"))
                        ),
                      ]),
                      _vm._l(
                        Object.keys(_vm.typeOperationToFilter).sort(),
                        function (key) {
                          return _c(
                            "option",
                            { key: key, domProps: { value: key } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.typeOperationToFilter[key]) +
                                  " "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                {
                  attrs: {
                    horizontal: "",
                    label: "Tipo",
                    "custom-class": "has-text-weight-normal",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "has-text-left" },
                    _vm._l(_vm.providersList, function (provider) {
                      return _c(
                        "label",
                        {
                          key: `label-provider-${provider}`,
                          staticClass: "checkbox is-block",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters.type,
                                expression: "filters.type",
                              },
                            ],
                            attrs: {
                              id: `checkbox-provider-${provider}`,
                              type: "checkbox",
                            },
                            domProps: {
                              value: provider,
                              checked: Array.isArray(_vm.filters.type)
                                ? _vm._i(_vm.filters.type, provider) > -1
                                : _vm.filters.type,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.filters.type,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = provider,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.filters,
                                        "type",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.filters,
                                        "type",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.filters, "type", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.providerDictionary[provider]) + " "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _c(
                "b-field",
                {
                  attrs: {
                    horizontal: "",
                    label: _vm.$t("generalWords.Search"),
                    "custom-class": "has-text-weight-normal",
                  },
                },
                [
                  _c("b-input", {
                    attrs: {
                      id: "search-input",
                      type: "search",
                      expanded: "",
                      icon: "search",
                      "icon-clickable": "",
                      disabled: !_vm.confirmableTransactionsLen,
                      placeholder: `id de ${_vm.$t(
                        "generalWords.transaction"
                      )}, ${_vm.$t("generalWords.idNumber")}, id CMF`,
                      size: "is-small",
                      rounded: "",
                    },
                    model: {
                      value: _vm.filters.searchInputVal,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "searchInputVal", $$v)
                      },
                      expression: "filters.searchInputVal",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "mt-3 mb-3 has-text-centered",
                  attrs: { id: "filter-info" },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("generalWords.Filtering")) + " "),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(_vm._s(_vm.filteredTransactionsLen)),
                  ]),
                  _vm._v(" de "),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(_vm._s(_vm.confirmableTransactionsLen)),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("generalWords.transactions")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _c("div", { staticClass: "double-bounce2" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-filter" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-layer-group" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }